
/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import store from '../store'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

Vue.use(Router)

// Create a new router
const router = new Router({
  base: '/',
  mode: 'history',
  routes: paths,

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

// Route guard checks to see if you are logged in, if not reroutes to login
// to is where you are going, matched.some is to find which routes have requiresAuth
router.beforeEach((to, from, next) => {
  store.dispatch("setPageTitle",to.meta.title);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authorized) {      
      let checkpages = store.getters.usermenu.filter(item=>{
        return to.path.indexOf(item.to) > -1 && item.to != '';
      });
      if(to.path != '/' && to.path != '/dashboard' && to.path != '/profile' && to.path.indexOf('/img/') == -1 && checkpages.length == 0){
        router.push("/404");
      }
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'dev'
    }
  })
}

export default router
